import {
  Box,
  Center,
  SimpleGrid,
} from "@chakra-ui/react";
import Cardvalues from "./cardvalues";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";

export default function ValueAdded() {
  return (
    <Box
    pt={20}>
      <LineSection />

      <Box
        color='white'
        pb={20}
      >

        <SectionHeading
          title="Value added"
          subtitle="" />

        <Center>
          <Box
            w={"8xl"}>
            <SimpleGrid
              columns={{ base: 1, md: 3, lg: 3, xl: 3 }}
              spacing={{ base: 5, md: 5, lg: 10, xl: 10 }}
            >
              <Cardvalues
                image="assets/Growth_icono.svg"
                texts="Personal Growth" />

              <Cardvalues
                image="assets/Comunity_icono.svg"
                texts="Community Strengthening" />

              <Cardvalues
                image="assets/Knowledge_icono.svg"
                texts="Knowledge Democratization" />

            </SimpleGrid>
          </Box>
        </Center>
      </Box>
    </Box>
  );
}